export default class RoleBasedIntegration{

    constructor() {
        jQuery(document).on('ywdpd_pre_update_price_html',this.syncRoleBasedPriceHTML.bind(this));
    }

    syncRoleBasedPriceHTML(event,table,mode,td){

        const priceHTML  = jQuery(table.data('price_html'));

       if(  priceHTML.find('.ywcrbp-role-price-rule').length ){
          const newPrice = priceHTML.find('.ywcrbp-role-price-rule .role-price .price').html();

           table.data('price_html', newPrice);
       }
    }
}